import ProjectForm from "./ProjectForm";

const UpdateProjectForm = ({ project, onSubmit, onCloseClicked }) => {
  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto md:min-w-[600px] pb-1">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Update Project</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <div className="flex items-center gap-6 px-4 py-4">
        <ProjectForm
          project={project}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  )
}

export default UpdateProjectForm;
